<app-header></app-header>
<ion-content
  id="invoice-history-page"
  class="gray-content-bg"
  [ngClass]="platformClass"
>
  <div class="page-content-wrapper">
    <ng-container *ngIf="isDesktop">
      <div class="header-wrapper">
        <app-breadcrumb activePageName="Invoice History"></app-breadcrumb>
        <ion-row class="title-row">
          <ion-col>
            <h1 class="page-title">INVOICE HISTORY</h1>
          </ion-col>
          <app-date-range-section
            [filterDateRange]="deliveryDateRange$ | async"
            (changeDateFilterClicked)="openModal(true)"
          ></app-date-range-section>
        </ion-row>
      </div>
      <div class="filter-header-container">
        <ion-row class="filtering-banner-container">
          <app-filter-section
            [numberOfSelectedFilters]="numberSelectedFilters$ | async"
            (filterClicked)="openModal()"
          ></app-filter-section>
        </ion-row>
      </div>
    </ng-container>

    <div class="filter-header-container" *ngIf="isTouch">
      <ion-grid fixed="true">
        <ion-row class="filtering-banner-container">
          <ng-container *ngIf="isTablet">
            <app-date-range-section
              [filterDateRange]="deliveryDateRange$ | async"
              (changeDateFilterClicked)="openModal(true)"
            ></app-date-range-section>
          </ng-container>

          <app-usf-filtering-banner-mobile
            *ngIf="isMobile"
            [isLoading]="false"
            [showQuickDateFilterOption]="true"
            [numberOfSelectedFilters]="numberSelectedFilters$ | async"
            (filterClicked)="openModal()"
            (changeDateFilterClicked)="openModal(true)"
            (resetFiltersClicked)="resetFilters()"
            [showResetFilterOption]="false"
            [filterDateRange]="deliveryDateRange$ | async"
            [resetLabel]="false"
            [showDateRange]="true"
          >
          </app-usf-filtering-banner-mobile>
        </ion-row>
        <ion-row *ngIf="isTablet" class="filter-section-container">
          <app-filter-section
            [numberOfSelectedFilters]="numberSelectedFilters$ | async"
            (filterClicked)="openModal()"
          ></app-filter-section>
        </ion-row>
      </ion-grid>
    </div>

    <div class="content-container">
      <div class="error-toast-container">
        <app-report-toast-container></app-report-toast-container>
      </div>
      <ion-grid fixed="true">
        <ion-row class="toast-container" *ngIf="isTouch">
          <ion-col>
            <app-data-usage-warning></app-data-usage-warning>
          </ion-col>
        </ion-row>
      </ion-grid>
      <ng-container *ngIf="noData && (isTableLoading$ | async) === false">
        <div class="no-data-container">
          <h2 class="no-data-title">There is no data to show</h2>
          <p class="no-data-label">
            Please adjust your
            <span class="no-data-label-link" (click)="openModal()">filters</span
            >.
          </p>
        </div>
      </ng-container>
      <app-report-table
        [dataSource]="dataSource"
        [columnsToDisplay]="columnsToDisplay"
        *ngIf="!noData && (isTableLoading$ | async) === false"
      ></app-report-table>
      <ng-container *ngIf="isTableLoading$ | async">
        <div class="table-skeleton-container">
          <ion-skeleton-text
            *ngFor="let bar of [1,2,3,4,5,6,7,8,9,10,11,12]"
            class="row-skeleton"
            animated
          ></ion-skeleton-text>
        </div>
      </ng-container>
    </div>
  </div>
  <app-footer></app-footer>
</ion-content>
